import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  MapPin, 
  Package, 
  Users,
  Calendar,
  X 
} from 'lucide-react';
import { useAdmin } from '../../context/AdminContext';
import './AdminSidebar.css';

const AdminSidebar = () => {
  const { sidebarOpen, toggleSidebar } = useAdmin();

    const menuItems = [
    {
      path: '/admin/dashboard',
      icon: LayoutDashboard,
      label: 'Dashboard',
    },
    {
      path: '/admin/bookings',
      icon: Calendar,
      label: 'Bookings',
    },
    {
      path: '/admin/locations',
      icon: MapPin,
      label: 'Locations',
    },
    {
      path: '/admin/equipment',
      icon: Package,
      label: 'Equipment',
    },
    {
      path: '/admin/talent',
      icon: Users,
      label: 'Talent',
    },
  ];

  return (
    <>
      {/* Backdrop for mobile */}
      {sidebarOpen && (
        <div className="sidebar-backdrop" onClick={toggleSidebar}></div>
      )}

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <span className="logo-text">IZZISHOWIN</span>
          </div>
          <button onClick={toggleSidebar} className="sidebar-close">
            <X size={24} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  `sidebar-link ${isActive ? 'active' : ''}`
                }
              >
                <Icon size={20} />
                <span className="sidebar-link-text">{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <div className="sidebar-footer-content">
            <p className="sidebar-footer-text">Version 1.0.0</p>
            <p className="sidebar-footer-text">© 2024 IZZISHOW</p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;